module.exports = __webpack_public_path__ + "static/media/logo.b176f519.svg";